import terytApi from '../api/terytApi';
import { actions as notificationActions } from './notificationActions';
import * as logger from '../utils/logger';

export const types = {
  GET_LOCALITIES: 'GET_LOCALITIES',
  GET_LOCALITIES_SUCCESS: 'GET_LOCALITIES_SUCCESS',
  GET_LOCALITIES_FAILURE: 'GET_LOCALITIES_FAILURE',
  GET_STREETS: 'GET_STREETS',
  GET_STREETS_SUCCESS: 'GET_STREETS_SUCCESS',
  GET_STREETS_FAILURE: 'GET_STREETS_FAILURE',
};

export const actions = {
  loadLocalities: terytPrefixFilter => dispatch => {
    dispatch({ type: types.GET_LOCALITIES });
    return terytApi.loadLocalities(terytPrefixFilter).then(res => {
      if (res.ok) {
        dispatch({ type: types.GET_LOCALITIES_SUCCESS, data: res.data });
      } else {
        dispatch({ type: types.GET_LOCALITIES_FAILURE });
        dispatch(notificationActions.showError('Nie udało się pobrać listy miejscowości'));

        return logger.error(res.data);
      }
    });
  },

  loadStreets: localityCode => dispatch => {
    dispatch({ type: types.GET_STREETS });
    return terytApi.loadStreets(localityCode).then(res => {
      if (res.ok) {
        dispatch({ type: types.GET_STREETS_SUCCESS, data: res.data });
      } else {
        dispatch({ type: types.GET_STREETS_FAILURE });
        dispatch(notificationActions.showError('Nie udało się pobrać listy miast'));

        return logger.error(res.data);
      }
    });
  },
};



// WEBPACK FOOTER //
// ./src/actions/terytActions.js